import React, { memo } from 'react';
import { Blok } from '../../interfaces/Blok.interface';
import Container from '../Utils/Container/Container';
import { LinkProps } from '../../interfaces/LinkProps.interface';
import StoryblokLinkProvider from '../Utils/StoryblokLinkProvider/StoryblokLinkProvider';
import ButtonLink from '../ButtonLink/ButtonLink';
import { ButtonType } from '../../interfaces/enums/ButtonType.enum';
import { ButtonSize } from '../../interfaces/enums/ButtonSize.enum';
import { withBlokWrapper } from '../BlokWrapper/BlokWrapper';
import { Theme } from '../../interfaces/enums/Theme.enum';

export interface DowntimeBannerBlokProps extends Blok {
    heading: string;
    description?: string;
    cta: LinkProps[];
    dismissButtonWasClicked: (bannerId: string) => void;
    enable_warning_logo: boolean
}

interface DowntimeBannerProps {
    blok: DowntimeBannerBlokProps
}

const DowntimeBanner: React.FC<DowntimeBannerProps> = ({ blok }) => {

    const { _uid, heading, description = undefined, cta = [], dismissButtonWasClicked, enable_warning_logo } = blok;

    return (
        <div className='bg-downtime-banner/downtime-banner-bg py-6'>
            <Container>
                <div className='relative flex flex-col items-center justify-center gap-y-6 sm:flex-row sm:items-center sm:justify-between sm:gap-y-0 sm:gap-x-4'>
                    <div className='flex items-center justify-start gap-x-5 text-[#334E5D] text-center sm:text-left'>
                        {enable_warning_logo && (
                        <div className='hidden sm:block'>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M1 21H23L12 2L1 21ZM13 18H11V16H13V18ZM13 14H11V10H13V14Z" fill="#B93700"/>
                            </svg>
                        </div>
                        )}
                        <div className='flex flex-col items-center justify-center sm:items-start sm:justify-start'>
                            <p className='font-bold'>{heading}</p>
                            {description && <p className='text-sm'>{description}</p>}
                        </div>
                    </div>
                    <div className='flex flex-col items-center justify-center sm:flex-row sm:justify-end sm:gap-x-10'>
                        {cta.map((ctaItem: LinkProps) => (
                            <StoryblokLinkProvider
                                key={ctaItem._uid}
                                link={ctaItem.link}
                                render={(link) => (
                                    <ButtonLink
                                        url={link}
                                        label={ctaItem.label}
                                        type={ButtonType.TERTIARY}
                                        size={ButtonSize.MD}
                                        className='whitespace-nowrap'
                                    >
                                        {ctaItem.label}
                                    </ButtonLink>
                                )}
                            />
                        ))}
                        <button className='absolute top-0 right-0 sm:static' onClick={() => dismissButtonWasClicked(_uid)}>
                            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M13.3 0.709971C12.91 0.319971 12.28 0.319971 11.89 0.709971L7 5.58997L2.11 0.699971C1.72 0.309971 1.09 0.309971 0.700001 0.699971C0.310001 1.08997 0.310001 1.71997 0.700001 2.10997L5.59 6.99997L0.700001 11.89C0.310001 12.28 0.310001 12.91 0.700001 13.3C1.09 13.69 1.72 13.69 2.11 13.3L7 8.40997L11.89 13.3C12.28 13.69 12.91 13.69 13.3 13.3C13.69 12.91 13.69 12.28 13.3 11.89L8.41 6.99997L13.3 2.10997C13.68 1.72997 13.68 1.08997 13.3 0.709971Z" fill="#0B212E"/>
                            </svg>
                        </button>
                    </div>
                </div>
            </Container>
        </div>
    )
}

export default memo(withBlokWrapper(DowntimeBanner, Theme.LIGHT));